var touch = false, clickEv = 'click', checkDropdown = [], checkSideMenu = [], checks_scroll = 0;
/*!
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery throttle / debounce: Sometimes, less is more!
//
// *Version: 1.1, Last updated: 3/7/2010*
//
// Project Home - http://benalman.com/projects/jquery-throttle-debounce-plugin/
// GitHub       - http://github.com/cowboy/jquery-throttle-debounce/
// Source       - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.js
// (Minified)   - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.min.js (0.7kb)
//
// About: License
//
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
//
// About: Examples
//
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
//
// Throttle - http://benalman.com/code/projects/jquery-throttle-debounce/examples/throttle/
// Debounce - http://benalman.com/code/projects/jquery-throttle-debounce/examples/debounce/
//
// About: Support and Testing
//
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
//
// jQuery Versions - none, 1.3.2, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-throttle-debounce/unit/
//
// About: Release History
//
// 1.1 - (3/7/2010) Fixed a bug in <jQuery.throttle> where trailing callbacks
//       executed later than they should. Reworked a fair amount of internal
//       logic as well.
// 1.0 - (3/6/2010) Initial release as a stand-alone project. Migrated over
//       from jquery-misc repo v0.4 to jquery-throttle repo v1.0, added the
//       no_trailing throttle parameter and debounce functionality.
//
// Topic: Note for non-jQuery users
//
// jQuery isn't actually required for this plugin, because nothing internal
// uses any jQuery methods or properties. jQuery is just used as a namespace
// under which these methods can exist.
//
// Since jQuery isn't actually required for this plugin, if jQuery doesn't exist
// when this plugin is loaded, the method described below will be created in
// the `Cowboy` namespace. Usage will be exactly the same, but instead of
// $.method() or jQuery.method(), you'll need to use Cowboy.method().

(function(window,undefined){
	'$:nomunge'; // Used by YUI compressor.

	// Since jQuery really isn't required for this plugin, use `jQuery` as the
	// namespace only if it already exists, otherwise use the `Cowboy` namespace,
	// creating it if necessary.
	var $ = window.jQuery || window.Cowboy || ( window.Cowboy = {} ),

		// Internal method reference.
		jq_throttle;

	// Method: jQuery.throttle
	//
	// Throttle execution of a function. Especially useful for rate limiting
	// execution of handlers on events like resize and scroll. If you want to
	// rate-limit execution of a function to a single time, see the
	// <jQuery.debounce> method.
	//
	// In this visualization, | is a throttled-function call and X is the actual
	// callback execution:
	//
	// > Throttled with `no_trailing` specified as false or unspecified:
	// > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	// > X    X    X    X    X    X        X    X    X    X    X    X
	// >
	// > Throttled with `no_trailing` specified as true:
	// > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	// > X    X    X    X    X             X    X    X    X    X
	//
	// Usage:
	//
	// > var throttled = jQuery.throttle( delay, [ no_trailing, ] callback );
	// >
	// > jQuery('selector').bind( 'someevent', throttled );
	// > jQuery('selector').unbind( 'someevent', throttled );
	//
	// This also works in jQuery 1.4+:
	//
	// > jQuery('selector').bind( 'someevent', jQuery.throttle( delay, [ no_trailing, ] callback ) );
	// > jQuery('selector').unbind( 'someevent', callback );
	//
	// Arguments:
	//
	//  delay - (Number) A zero-or-greater delay in milliseconds. For event
	//    callbacks, values around 100 or 250 (or even higher) are most useful.
	//  no_trailing - (Boolean) Optional, defaults to false. If no_trailing is
	//    true, callback will only execute every `delay` milliseconds while the
	//    throttled-function is being called. If no_trailing is false or
	//    unspecified, callback will be executed one final time after the last
	//    throttled-function call. (After the throttled-function has not been
	//    called for `delay` milliseconds, the internal counter is reset)
	//  callback - (Function) A function to be executed after delay milliseconds.
	//    The `this` context and all arguments are passed through, as-is, to
	//    `callback` when the throttled-function is executed.
	//
	// Returns:
	//
	//  (Function) A new, throttled, function.

	$.throttle = jq_throttle = function( delay, no_trailing, callback, debounce_mode ) {
		// After wrapper has stopped being called, this timeout ensures that
		// `callback` is executed at the proper times in `throttle` and `end`
		// debounce modes.
		var timeout_id,

			// Keep track of the last time `callback` was executed.
			last_exec = 0;

		// `no_trailing` defaults to falsy.
		if ( typeof no_trailing !== 'boolean' ) {
			debounce_mode = callback;
			callback = no_trailing;
			no_trailing = undefined;
		}

		// The `wrapper` function encapsulates all of the throttling / debouncing
		// functionality and when executed will limit the rate at which `callback`
		// is executed.
		function wrapper() {
			var that = this,
				elapsed = +new Date() - last_exec,
				args = arguments;

			// Execute `callback` and update the `last_exec` timestamp.
			function exec() {
				last_exec = +new Date();
				callback.apply( that, args );
			};

			// If `debounce_mode` is true (at_begin) this is used to clear the flag
			// to allow future `callback` executions.
			function clear() {
				timeout_id = undefined;
			};

			if ( debounce_mode && !timeout_id ) {
				// Since `wrapper` is being called for the first time and
				// `debounce_mode` is true (at_begin), execute `callback`.
				exec();
			}

			// Clear any existing timeout.
			timeout_id && clearTimeout( timeout_id );

			if ( debounce_mode === undefined && elapsed > delay ) {
				// In throttle mode, if `delay` time has been exceeded, execute
				// `callback`.
				exec();

			} else if ( no_trailing !== true ) {
				// In trailing throttle mode, since `delay` time has not been
				// exceeded, schedule `callback` to execute `delay` ms after most
				// recent execution.
				//
				// If `debounce_mode` is true (at_begin), schedule `clear` to execute
				// after `delay` ms.
				//
				// If `debounce_mode` is false (at end), schedule `callback` to
				// execute after `delay` ms.
				timeout_id = setTimeout( debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay );
			}
		};

		// Set the guid of `wrapper` function to the same of original callback, so
		// it can be removed in jQuery 1.4+ .unbind or .die by using the original
		// callback as a reference.
		if ( $.guid ) {
			wrapper.guid = callback.guid = callback.guid || $.guid++;
		}

		// Return the wrapper function.
		return wrapper;
	};

	// Method: jQuery.debounce
	//
	// Debounce execution of a function. Debouncing, unlike throttling,
	// guarantees that a function is only executed a single time, either at the
	// very beginning of a series of calls, or at the very end. If you want to
	// simply rate-limit execution of a function, see the <jQuery.throttle>
	// method.
	//
	// In this visualization, | is a debounced-function call and X is the actual
	// callback execution:
	//
	// > Debounced with `at_begin` specified as false or unspecified:
	// > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	// >                          X                                 X
	// >
	// > Debounced with `at_begin` specified as true:
	// > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
	// > X                                 X
	//
	// Usage:
	//
	// > var debounced = jQuery.debounce( delay, [ at_begin, ] callback );
	// >
	// > jQuery('selector').bind( 'someevent', debounced );
	// > jQuery('selector').unbind( 'someevent', debounced );
	//
	// This also works in jQuery 1.4+:
	//
	// > jQuery('selector').bind( 'someevent', jQuery.debounce( delay, [ at_begin, ] callback ) );
	// > jQuery('selector').unbind( 'someevent', callback );
	//
	// Arguments:
	//
	//  delay - (Number) A zero-or-greater delay in milliseconds. For event
	//    callbacks, values around 100 or 250 (or even higher) are most useful.
	//  at_begin - (Boolean) Optional, defaults to false. If at_begin is false or
	//    unspecified, callback will only be executed `delay` milliseconds after
	//    the last debounced-function call. If at_begin is true, callback will be
	//    executed only at the first debounced-function call. (After the
	//    throttled-function has not been called for `delay` milliseconds, the
	//    internal counter is reset)
	//  callback - (Function) A function to be executed after delay milliseconds.
	//    The `this` context and all arguments are passed through, as-is, to
	//    `callback` when the debounced-function is executed.
	//
	// Returns:
	//
	//  (Function) A new, debounced, function.

	$.debounce = function( delay, at_begin, callback ) {
		return callback === undefined
			? jq_throttle( delay, at_begin, false )
			: jq_throttle( delay, callback, at_begin !== false );
	};

})(this);
/* slider product*/
function sliderProduct(){
  /* Slider Relatedpro */
  if($(".related-products .rp-slider").length){
    $(".related-products .rp-slider").owlCarousel({
      navigation : true,
      pagination: false,
      items: 5,
      slideSpeed : 200,
      autoPlay: 2000,
      stopOnHover: true,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1920,5],
      itemsDesktopSmall : [1599,5],
      itemsTablet: [1199,4],
      itemsTabletSmall: [991,3],
      itemsMobile : [767,2]
    });
  } 
  /* Slider Viewed */
  if($(".viewed-slider-products").length){
    $(".viewed-slider-products").owlCarousel({
      navigation : true,
      pagination: false,
      autoPlay: 2000,
      stopOnHover: true,
      items: 6,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1920,6],
      itemsDesktopSmall : [1599,5],
      itemsTablet: [1199,4],
      itemsTabletSmall: [991,3],
      itemsMobile : [767,2]
    });
  } 
  /* Slider best sellers list collection*/
  if($(".best-sellers-slider-products").length){
    $(".best-sellers-slider-products").owlCarousel({
      navigation : true,
      pagination: true,
      items: 4,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1920,4],
      itemsDesktopSmall : [1599,4],
      itemsTablet: [1199,3],
      itemsTabletSmall: [991,2],
      itemsMobile : [767,2]
    });
  } 
  
  /* Slider Thumb */
  if($(".thumbs-mobile .slider-3itemsc").length){
    $(".thumbs-mobile .slider-3itemsc").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      focusOnSelect: true
    });
  }
  $(".show-load-detail").css("display", "none");
  
  /* Testimonials product */
  if($(".testimonials-product-content").length){
    $(".testimonials-product-content").owlCarousel({
      navigation : false,
      pagination: true,
      autoPlay: false,
      items: 1,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,1],
      itemsDesktopSmall : [991,1],
      itemsTablet: [767,1],
      itemsTabletSmall: [540,1],
      itemsMobile : [420,1]
    });
  }
}
/* slider product*/
function sliderBlog(){
  if($(".related-blog-slider").length){
    $(".related-blog-slider").owlCarousel({
      navigation : true,
      pagination: false,
      autoPlay: false,
      items: 3,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,1],
      itemsDesktopSmall : [991,1],
      itemsTablet: [767,1],
      itemsTabletSmall: [540,1],
      itemsMobile : [360,1]
    });
  }
}

/* Handle dropdown box */
function handleDropdown(){
  var changeIcon = function() {
    $( ".dropdownMobile-toggle" ).each(function( index ) {
      $(this).parent().find('.dropdown-menu').hide();
      $(this).removeClass('active-dropdown');
      var icon_class=$(this).find('.icon-dropdown').data('class');
      $(this).find('.icon-dropdown').attr('class','icon-dropdown '+icon_class);
    });
  }
  var dropdownDesktop = function() {
    if($('.dropdown-toggle').length){
      $('.dropdown-toggle').parent().hover(function (){
        if(touch == false && getWidthBrowser() > 767 ){
          $(this).find('.dropdown-menu').stop(true, true).slideDown(300);
        }
      }, function (){
        if(touch == false && getWidthBrowser() > 767 ){
          $(this).find('.dropdown-menu').hide();
        }
      });
    }
  }
  var dropdownTablet = function(){
    if($('.dropdownMobile-toggle').length){
      $('.dropdownMobile-toggle').on('click', function() {
        if(!$(this).hasClass('active-dropdown')){
          changeIcon();
          $('body').addClass('active-overflow');
          $(this).parent().find('.dropdown-menu').stop(true, true).slideDown(300);
          $(this).addClass('active-dropdown');
          $(this).find('.icon-dropdown').attr('class','icon-dropdown cs-icon icon-close');
        }
        else{
          $('body').removeClass('active-overflow');
          changeIcon();
        }
      });
    }
  }
  $('nav .dropdown-menu').each(function(){
    $(this).find('li').last().addClass('last');
  });
  $('.dropdown').on('click', function() {
    if(touch == false && getWidthBrowser() > 767 ){
      var href = $(this).find('.dropdown-link').attr('href');
      window.location = href;
    }
  });
  $('.dropdown-1 .dropdown-link').on('click', function() {
    if(touch == false && getWidthBrowser() > 767 ){
      var href = $(this).attr('href');
      window.location = href;
    }
  });
  dropdownDesktop();
  dropdownTablet();
}

/* Fucntion get width browser */
function getWidthBrowser() {
  var myWidth;

  if( typeof( window.innerWidth ) == 'number' ) { 
    //Non-IE 
    myWidth = window.innerWidth;
    //myHeight = window.innerHeight; 
  } 
  else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
    //IE 6+ in 'standards compliant mode' 
    myWidth = document.documentElement.clientWidth; 
    //myHeight = document.documentElement.clientHeight; 
  } 
  else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
    //IE 4 compatible 
    myWidth = document.body.clientWidth; 
    //myHeight = document.body.clientHeight; 
  }

  return myWidth;
}

// handle scroll-to-top button
function handleScrollTop() {
  function totop_button(a) {
    var b = $("#scroll-to-top"),
        f = $(".cart-float-right");

    if (a == "on") { 
      f.addClass("on fadeInRight ").removeClass("off fadeOutRight");
      b.addClass("on fadeInRight ").removeClass("off fadeOutRight"); 
    } else {
      f.addClass("off fadeOutRight animated").removeClass("on fadeInRight");
      b.addClass("off fadeOutRight animated").removeClass("on fadeInRight"); 
    }
  }
  $(window).scroll(function() {
    var b = $(this).scrollTop();
    var c = $(this).height();
    if (b > 0) { 
      var d = b + c / 2;
    } 
    else { 
      var d = 1 ;
    }    
    if (d < 1e3 && d < c) { 
      totop_button("off");
    } 
    else {
      totop_button("on"); 
    }
  });  

}   

//newsletter popup
function ModalNewsletter(){
  var showNewsletter = function(date){
    $('#newsletter-popup').modal('toggle');
    $('.nl-wraper-popup').addClass('animated'); 
    var tnout = 20 ;
    setTimeout (function() { 
      $('#newsletter-popup').modal('hide');
    }, tnout*1000 );
    localStorage.setItem('cs-newsletter', date );
  }
  var checkNewsletter = function(){
    var date = '10/15/2026 09:04:23';
    if(localStorage.getItem('cs-newsletter') == null || localStorage.getItem('cs-newsletter') == "undefined" ){
	  showNewsletter(date);
    }
    else{
      var check_time = new Date(date) - new Date(localStorage.getItem('cs-newsletter'));
      var ms = check_time % 1000;
      check_time = (check_time - ms) / 1000;
      var days = Math.floor(check_time / 86400);
      if(days > 7){
        showNewsletter(date);
      }
    }
  }
  
}

/* Handle product quantity */
function handleQuantity(){
  if($('.quantity-wrapper').length){
    $('.quantity-wrapper').on(clickEv, '.qty-up', function() {
      var $this = $(this);
      var qty = $this.parents('.wrapper').find('input');
      $(qty).val(parseInt($(qty).val()) + 1);
    });
    $('.quantity-wrapper').on(clickEv, '.qty-down', function() {
      var $this = $(this);
      var qty = $this.parents('.wrapper').find('input');
      if(parseInt($(qty).val()) > 1)
        $(qty).val(parseInt($(qty).val()) - 1);
    });
  }
}

function colorwarches(){
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  }); 
}

function toggleTagsFilter(){ 
  if(window.innerWidth >= 768 ){
    var tagsbutton = document.getElementById( 'showTagsFilter' ),    
        tagscontent = document.getElementById( 'tags-filter-content' );    
    if(tagsbutton != null ){
      tagsbutton.onclick = function() {
        classie.toggle( this, 'closed' );
        classie.toggle( tagscontent, 'tags-closed' );
        if(classie.has( this, 'closed' ))
          $('#showTagsFilter').html("Filter <i class='fa fa-angle-down'></i>");
        else $('#showTagsFilter').html("Filter <i class='fa fa-angle-up'></i>");
      };
    }
  }
}

/* Function update scroll product thumbs */
function updateScrollThumbsQS(){
  if($('#gallery_main_qs').length){

    $('#quick-shop-image .fancybox').on(clickEv, function() {
      var _items = [];
      var _index = 0;
      var product_images = $('#gallery_main_qs .image-thumb a');
      product_images.each(function(key, val) {
        _items.push({'href' : val.href, 'title' : val.title});
        if($(this).hasClass('active')){
          _index = key;
        }
      });
      $.fancybox(_items,{
        closeBtn: true,
        index: _index,
        helpers: {
          buttons: {}
        }
      });
      return false;
    });

    $('#quick-shop-image').on(clickEv, '.image-thumb a', function() {

      var $this = $(this);
      var background = $('.product-image .main-image .main-image-bg');
      var parent = $this.parents('.product-image-wrapper');
      var src_original = $this.attr('data-image-zoom');
      var src_display = $this.attr('data-image');

      background.show();

      parent.find('.image-thumb').removeClass('active');
      $this.parent().addClass('active');

      parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
      parent.find('.main-image').find('img').attr('src', src_display).load(function() {
        background.hide();
      });

      return false;
    });
  }
}

//Change Quantity Quick Show
function change_qs_quantity(qs){
  qs_quantity=qs;
}

function showMenuMobile(){
  var $doc = $(document);
  var $body = $('body');
  var menuOverlaySelector = '.group_navbtn_action .navigation_dropdown_scroll';

  var getRoot = function(){
    return $('#top-activeRight').length ? $('#top-activeRight') : $('#top');
  };

  var openRoot = function(){
    if ($('#top').length) $('#top').attr('id', 'top-activeRight');
  };

  var closeRootIfIdle = function(){
    var $active = $('#top-activeRight');
    if (!$active.length) return;

    var menuOpen = $(menuOverlaySelector).hasClass('hover-dropdown') || $(menuOverlaySelector).hasClass('active-dropdown');
    var infoOpen = $active.find('.info-header').hasClass('active');

    if (!menuOpen && !infoOpen) {
      $active.attr('id', 'top');
      $body.removeClass('active-overflow');
    }
  };

  var resetMegaIcons = function(){
    $('.navigation_mobile .arrow').removeClass('class_test').attr('aria-expanded', 'false');
    $('.navigation_mobile .arrow i').attr('class', 'cs-icon icon-ios-plus-empty');
    $('.navigation_mobile').removeClass('active_dropdown');
    $('.navigation_mobile .menu-mobile-container').hide("fast");
  };

  var resetSubmenuIcons = function(){
    $('.navigation_sub_mobile .arrow_sub_mobile').removeClass('class_test').attr('aria-expanded', 'false');
    $('.navigation_sub_mobile .arrow_sub_mobile i').attr('class', 'cs-icon icon-ios-plus-empty');
    $('.navigation_sub_mobile').removeClass('active_dropdown');
    $('.navigation_sub_mobile .sub-menu-mobile-container').hide("fast");
  };

  var closeMenuDrawer = function(){
    $('.group_navbtn_action .dropdown-toggle-navigation').removeClass('active-dropdown');
    $(menuOverlaySelector).removeClass('hover-dropdown active-dropdown');
    resetMegaIcons();
    resetSubmenuIcons();
    closeRootIfIdle();
  };

  var openMenuDrawer = function($trigger){
    if ($trigger && $trigger.length) $trigger.addClass('active-dropdown');
    $(menuOverlaySelector).addClass('hover-dropdown');
    openRoot();
    $body.addClass('active-overflow');
  };

  var openInfoPanel = function(classShow){
    if (!classShow) return false;
    var $root = getRoot();
    if (!$root.length) return false;

    var $target = $root.find('.' + classShow);
    if (!$target.length) return false;

    // If the account panel only has tab toggles but no actual auth forms, let the link navigate.
    if (classShow === 'info-header-sidebar') {
      var hasTabToggles = $target.find('.login-register-content .nav-tabs a[data-toggle="tab"]').length > 0;
      var hasAuthForms = $target.find('form input[name="customer[email]"], form input[name="customer[password]"]').length > 0;
      if (hasTabToggles && !hasAuthForms) return false;
    }

    $root.find('.info-header .info-header-item').removeClass('active-show');
    $root.find('.info-header').removeClass('is-sidebar is-cart is-compare');
    $target.addClass('active-show');
    $root.find('.info-header').addClass('active');
    if (classShow === 'info-header-sidebar') $root.find('.info-header').addClass('is-sidebar');
    openRoot();
    $body.addClass('active-overflow');
    return true;
  };

  var closeInfoPanel = function(){
    var $root = getRoot();
    if (!$root.length) return;

    $root.find('.info-header .info-header-item').removeClass('active-show');
    $root.find('.info-header').removeClass('active is-sidebar is-cart is-compare');
    closeRootIfIdle();
  };

  $doc.off('click.mobileMenuOpen', '.group_navbtn_action .dropdown-toggle-navigation');
  $doc.on('click.mobileMenuOpen', '.group_navbtn_action .dropdown-toggle-navigation', function(e) {
    if (e && e.preventDefault) e.preventDefault();
    openMenuDrawer($(this));
  });

  $doc.off('click.mobileMenuClose', '.group_navbtn_action .close-navigation-dropdown, .group_navbtn_action .navigation_dropdown_scroll_close');
  $doc.on('click.mobileMenuClose', '.group_navbtn_action .close-navigation-dropdown, .group_navbtn_action .navigation_dropdown_scroll_close', function(e) {
    if (e && e.preventDefault) e.preventDefault();
    closeMenuDrawer();
  });

  $doc.off('click.mobileMegaMenu', '.navigation_mobile .arrow');
  $doc.on('click.mobileMegaMenu', '.navigation_mobile .arrow', function(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (e && e.stopPropagation) e.stopPropagation();

    var $button = $(this);
    var $item = $button.closest('.navigation_mobile');
    var $menu = $item.children('.menu-mobile-container').first();
    var isOpen = $button.hasClass('class_test');

    if (isOpen) {
      $button.removeClass('class_test').attr('aria-expanded', 'false');
      $button.find('i').attr('class', 'cs-icon icon-ios-plus-empty');
      $item.removeClass('active_dropdown');
      $menu.hide("fast");
      return;
    }

    resetMegaIcons();
    $button.addClass('class_test').attr('aria-expanded', 'true');
    $button.find('i').attr('class', 'cs-icon icon-ios-minus-empty');
    $item.addClass('active_dropdown');
    $menu.show("fast");
  });

  $doc.off('click.mobileSubMenu', '.navigation_sub_mobile .arrow_sub_mobile');
  $doc.on('click.mobileSubMenu', '.navigation_sub_mobile .arrow_sub_mobile', function(e){
    if (e && e.preventDefault) e.preventDefault();
    if (e && e.stopPropagation) e.stopPropagation();

    var $button = $(this);
    var $item = $button.closest('.navigation_sub_mobile');
    var $menu = $item.children('.sub-menu-mobile-container').first();
    var isOpen = $button.hasClass('class_test');

    if (isOpen) {
      $button.removeClass('class_test').attr('aria-expanded', 'false');
      $button.find('i').attr('class', 'cs-icon icon-ios-plus-empty');
      $item.removeClass('active_dropdown');
      $menu.hide("fast");
      return;
    }

    var $siblings = $item.siblings('.navigation_sub_mobile');
    $siblings.removeClass('active_dropdown').find('.sub-menu-mobile-container').hide("fast");
    $siblings.find('.arrow_sub_mobile').removeClass('class_test').attr('aria-expanded', 'false');
    $siblings.find('.arrow_sub_mobile i').attr('class', 'cs-icon icon-ios-plus-empty');

    $button.addClass('class_test').attr('aria-expanded', 'true');
    $button.find('i').attr('class', 'cs-icon icon-ios-minus-empty');
    $item.addClass('active_dropdown');
    $menu.show("fast");
  });

  $doc.off('click.mobileInfoOpen', '.icon_info .show-info');
  $doc.on('click.mobileInfoOpen', '.icon_info .show-info', function(e) {
    var handled = openInfoPanel($(this).data('class'));
    if (handled && e && e.preventDefault) e.preventDefault();
  });

  $doc.off('click.mobileInfoClose', '.info-header .close-info, .info-header .info-header-close');
  $doc.on('click.mobileInfoClose', '.info-header .close-info, .info-header .info-header-close', function(e) {
    if (e && e.preventDefault) e.preventDefault();
    closeInfoPanel();
  });

  $doc.off('click.mobileMenuLink', '.navigation_dropdown_scroll .mobile-goto-link');
  $doc.on('click.mobileMenuLink', '.navigation_dropdown_scroll .mobile-goto-link', function() {
    closeMenuDrawer();
  });

  $doc.off('keyup.mobileEscape');
  $doc.on('keyup.mobileEscape', function(e){
    if (!e || (e.key !== 'Escape' && e.keyCode !== 27)) return;
    closeMenuDrawer();
    closeInfoPanel();
  });
}

function showItemMobile(){
  $('.item-dropdown-mobile .btn-group').on('click', '.dropdown-toggle', function() {
    $('.item-dropdown-mobile .dropdown-menu').css('display','none');

    if($(this).hasClass('active_popup')){
      $(this).removeClass('active_popup');
    }
    else{
      $('.item-dropdown-mobile .dropdown-toggle').removeClass('active_popup');
      $(this).addClass('active_popup');
      $('.item-dropdown-mobile').each(function(){
        if($(this).find('.dropdown-toggle').hasClass('active_popup')){
          $(this).find('.dropdown-menu').css('display','block');
        }
      });
    }
  });
}

function showPassword(){
  $(document).off(clickEv + '.showPassword', '.form-password .cs-icon');
  $(document).on(clickEv + '.showPassword', '.form-password .cs-icon', function(e) {
    if (e && e.preventDefault) e.preventDefault();

    var $toggle = $(this);
    var $inputGroup = $toggle.closest('.group_input_pass, ._group-input, .form-password');
    var $input = $inputGroup.find('input').first();
    if (!$input.length) return;

    if($toggle.hasClass("show-pass")){
      $input.attr('type','password');
      $toggle.removeClass("show-pass");
    }
    else{
      $input.attr('type','text');
      $toggle.addClass("show-pass");
    }
  });
}

function capsLockHint(){
  var ensureHint = function($input){
    var $hint = $input.data('capsLockHint');
    if ($hint && $hint.length) return $hint;

    $hint = $('<div class="caps-lock-hint" aria-live="polite" style="display:none;">Caps Lock is on</div>');

    // Insert after the field container so the eye icon stays centered on the input.
    var $fp = $input.closest('.form-password');
    if ($fp.length) $fp.after($hint);
    else $input.after($hint);

    $input.data('capsLockHint', $hint);
    return $hint;
  };

  // Delegate so it works for dynamically shown forms (header sidebar, modals, etc).
  $(document).on('keydown keyup', '.form-password input', function(e) {
    var $input = $(this);
    var $hint = ensureHint($input);
    var isOn = !!(e && e.getModifierState && e.getModifierState('CapsLock'));
    if (isOn) $hint.show();
    else $hint.hide();
  });

  $(document).on('blur', '.form-password input', function() {
    var $hint = $(this).data('capsLockHint');
    if ($hint && $hint.length) $hint.hide();
  });
}

function sidebarBlog(){
  $(".sidebar-block .sidebar-title").on(clickEv, '.cs-icon', function() {
    if($(this).hasClass("show-content")){
      $(this).parents('.sidebar-block').find(".sidebar-content").slideToggle();
      $(this).attr('class','cs-icon icon-ios-minus-empty');
    }
    else{
      $(this).parents('.sidebar-block').find(".sidebar-content").slideToggle();
      $(this).attr('class','show-content cs-icon icon-ios-plus-empty');
    }
  });
  
  $(".sidebar-block .sidebar-title").on(clickEv, '.fa', function() {
    if($(this).hasClass("show-content")){
      $(this).parents('.sidebar-block').find(".sidebar-content").slideToggle();
      $(this).attr('class','fa fa-angle-double-right');
    }
    else{
      $(this).parents('.sidebar-block').find(".sidebar-content").slideToggle();
      $(this).attr('class','show-content fa fa-angle-double-down');
    }
  });
}

function tagFilterCollection(){
  var newQuery = '';
  var init = function(){
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }
  var createUrl = function(url,queryParams){
    history.pushState({
      param: queryParams
    }, url, url);
    $.ajax({
      type: 'GET',
      url: url,
      data: {},
      beforeSend: function( xhr ) {
        $("#tags-load").show();
      },
      complete: function (data) {  
        $('#collection').html($("#collection", data.responseText).html());      
        $("#tags-load").hide();
        var urls = "\/\/productreviews.shopifycdn.com\/assets\/v4\/spr.js?shop=";
        $.getScript(urls, function() {
        });
        handleGridList();
        toggleTagsFilter();
        $(GLOBAL['common']['init']);
        filterClick();
        sidebarBlog();
        clearFilterMobile();
        clearFilterFullwidth();
        applyFilterMobile();
        paginationCollection();
        showFilter();
        initPriceSlider();

        if(checkCollection == 1){
          removeFilter();
        }
        handleDropdown();
        collectionTopFilter();
        $.each($('.new-filters .filter-content'), function (i) {
          if ($(this).find('.tab-fil-item.active').length) {
            $(this).find('.tab-fil-item:not(.active)').addClass('opacity');
            $('.filter-content.tab-content').removeClass('current')
            $(this).find('.tab-fil-item.active').parents('.filter-content.tab-content').addClass('current')
            $('.tab-link').removeClass('current')
            $('.tab-link[data-tab="'+  $(this).find('.tab-fil-item.active').parents('.filter-content.tab-content').attr('id') +'"]').addClass('current')
          }
        })
        $.each($('.sidebar-block.filter-block'), function (i) {
          if ($(this).find('.filter-content li.active').length) {
            $(this).find('.filter-content li:not(.active)').addClass('disabled')
          }
        })
      }
    });
  }
  var initPriceSlider = function () {
		var setMin = 0;
		var setMax = 50000;

  	    if(Shopify.queryParams != undefined) {
            if(Shopify.queryParams.price != undefined) {

                var priceParamVal = Shopify.queryParams.price.split('*');
                setMin = parseInt(priceParamVal[0]);
                setMax = parseInt(priceParamVal[1]);
            }
         }

		var $priceMin = $('.price-range .price-min');
		var $priceMax = $('.price-range .price-max');

    var sliderToPrice = function(v){
      v = Math.max(0, Math.min(100, v));
      if(v <= 50){
        return Math.round((v/50)*10000);
      }
      return Math.round(10000 + ((v-50)/50)*40000);
    };
    var formatPrice = function(p){
      p = Math.round(p);
      return (''+p).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    var priceToSlider = function(p){
      p = Math.max(0, Math.min(50000, p));
      if(p <= 10000){
        return (p/10000)*50;
      }
      return 50 + ((p-10000)/40000)*50;
    };

    var sliderFrom = priceToSlider(setMin);
    var sliderTo = priceToSlider(setMax);

    var applyPriceRange = function(realFrom, realTo){
      if (window.location.search) {
        Shopify.queryParams.price = realFrom + '*' + realTo
        if (window.location.search.indexOf('price') != -1) {
          window.history.replaceState(Shopify.queryParams.price, null,  window.location.search.split('&price=')[0] + '&price=' + realFrom + '*' + realTo);
        } else {
          window.history.replaceState(Shopify.queryParams.price, null,  window.location.search + '&price=' + realFrom + '*' + realTo);
        }
      } else {
        Shopify.queryParams.price = realFrom + '*' + realTo
        window.history.replaceState(Shopify.queryParams.price, null,  window.location.search + '?price=' + realFrom + '*' + realTo);
      }

      var $collectionPlpGrid = $('#collection .products');
      var numberOfPages = parseInt($('[data-pages]').attr('data-pages'));

      if (numberOfPages > 1){
         if (!$('#tags-load').is(':visible') ) {
           $("#tags-load").show();
           getProducts(numberOfPages, 2, $collectionPlpGrid, realFrom, realTo);
         }

      } else {
          setTimeout(function () {
              $('.product-item').each(function () {
                  var thisPrice = parseInt($(this).attr('data-price') / 100);

                  if (thisPrice < realFrom || thisPrice > realTo) {
                      $(this).addClass('hide')
                  } else {
                      $(this).removeClass('hide')
                  }
              });
          },0)
      }
    };

		$(".js-range-slider").ionRangeSlider({
			type: "double",
			skin: "round",
			min: 0,
			max: 100,
			from: sliderFrom,
			to: sliderTo,
			grid: false,
			hide_min_max: true,
			prefix: '$',
			prettify: function (num) { return formatPrice(sliderToPrice(num)); },
			onChange: function (data) {

        var realFrom = sliderToPrice(data.from);
        var realTo = sliderToPrice(data.to);

				$priceMin.val(realFrom);
				$priceMax.val(realTo);

			},
			onFinish: function () {
				var $priceInputs = $(".price-range-input");

				$priceInputs.trigger('change');
			}
		});

		$(document).off('input.priceRange', ".price-range-input");
		$(document).on('input.priceRange', ".price-range-input", $.debounce(300, function () {
			var priceMax = parseFloat($('.price-range .price-max').attr('max'));

			if (parseFloat($(this).val()) > priceMax) {
				$(this).val(priceMax)
			}

			var priceMaxValue = $('.price-range .price-max').val();
			var priceMinValue = $('.price-range .price-min').val();
			var priceSlider = $(".js-range-slider").data("ionRangeSlider");

			priceSlider.update({
				from: priceToSlider(priceMinValue),
				to: priceToSlider(priceMaxValue)
			});
		}));

    $(document).off('click.priceRange', '.price-range-confirm');
    $(document).on('click.priceRange', '.price-range-confirm', function(){
      var fromVal = parseInt($priceMin.val(), 10);
      var toVal = parseInt($priceMax.val(), 10);

      if (isNaN(fromVal)) fromVal = 0;
      if (isNaN(toVal)) toVal = 50000;

      fromVal = Math.max(0, Math.min(50000, fromVal));
      toVal = Math.max(0, Math.min(50000, toVal));

      if (fromVal > toVal) {
        var tmp = fromVal;
        fromVal = toVal;
        toVal = tmp;
        $priceMin.val(fromVal);
        $priceMax.val(toVal);
        var sliderInst = $(".js-range-slider").data("ionRangeSlider");
        if (sliderInst) {
          sliderInst.update({
            from: priceToSlider(fromVal),
            to: priceToSlider(toVal)
          });
        }
      }

      applyPriceRange(fromVal, toVal);
    });

		$priceMin.val(setMin);
		$priceMax.val(setMax);

		if(Shopify.queryParams != undefined) {
			if(Shopify.queryParams.price != undefined) {

                var $collectionPlpGrid = $('#collection .products');
                var numberOfPages = parseInt($('[data-pages]').attr('data-pages'));
                if (numberOfPages > 1){
                    $("#tags-load").show();

                    getProducts(numberOfPages, 2, $collectionPlpGrid, setMin, setMax);
                } else {
                	setTimeout(function () {
                        $('.product-item').each(function () {
                            var thisPrice = parseInt($(this).attr('data-price') / 100);
                            if ( thisPrice < setMin ||  thisPrice > setMax) {
                                $(this).addClass('hide')
                            } else {
                                $(this).removeClass('hide')
                            }
                        })

                    }, 0)
                }
			}
		}

		// Get Products from Page
		function getProducts(numberOfPages, i, $collectionGrid, setMin, setMax){
			var searchUrl = window.location.search;
			var nextPageUrl = window.location.pathname + "?page=" + i;

			if (searchUrl !== ''){
				nextPageUrl += '&' + searchUrl.replace('?', '');
			}

			$('.product-counter, .group-right, .collection-bottom-toolbar').hide()

			$.get(nextPageUrl, function(data) {

				var products = $(data).find('#collection .products').html();

				$collectionGrid.append(products);

        if (i+1 <= numberOfPages){
          setTimeout(function(){
            getProducts(numberOfPages, i+1, $collectionGrid, setMin, setMax);
          }, 400);
        } else {
					setTimeout(function () {
                        $('.product-item').each(function () {
                            var thisPrice = parseInt($(this).attr('data-price') / 100);
                            if ( thisPrice < setMin ||  thisPrice > setMax) {
                                $(this).addClass('hide')
                            } else {
                                $(this).removeClass('hide')
                            }
                        });
                        }, 200)


					$("#tags-load").hide();
                    $('[data-pages]').attr('data-pages', 0);
                }
			});
		}
	}

	var filterClick = function(){
    $('.filter-content li > a:not(.just-link)').click(function(event) {
      event.preventDefault();
      var newTags = [];
      if (Shopify.queryParams.constraint) {
        newTags = Shopify.queryParams.constraint.split('+');
      }
      var dataHandle = $(this).parents('li').data("handle");

      if (dataHandle) {
        var tagCheck = newTags.indexOf(dataHandle);
        if (tagCheck >= 0) {
          newTags.splice(tagCheck, 1);
        } else {
          if ($(this).parents('.filter-content').find('.tab-fil-item.active').length && !$(this).parent().hasClass('active')) {
            var activeTabItem = $(this).parents('.filter-content').find('.tab-fil-item.active').attr('data-handle');
            var newTagCheck = newTags.indexOf(activeTabItem)

            newTags.splice(newTagCheck, 1);
            newTags.push(dataHandle);
          } else {
            newTags.push(dataHandle);
          }
        }
      }
      if (newTags.length) {
        Shopify.queryParams.constraint = newTags.join('+');
      } else {
        delete Shopify.queryParams.constraint;
      }
      delete Shopify.queryParams.page;
      newQuery = jQuery.param(Shopify.queryParams).replace(/%2B/g, '+');

      if(getWidthBrowser() > 991 ){
        var url = location.pathname + "?" + newQuery;
        createUrl(url,Shopify.queryParams);
      }
			if($(this).parents('li').hasClass('active')){
				$(this).parents('li').removeClass('active');
			}
			else{
				$(this).parents('li').addClass('active');
			}
    });
  }
  var clearFilterMobile = function(){
    $('.collection-leftsidebar .sidebarMobile-clear').on(clickEv, function() {
      var url = location.pathname ;
      createUrl(url,url);
      $('#collection .collection-leftsidebar').removeClass('active');
      $('body').removeClass('active-sidebar');
    });
  }
  var clearFilterFullwidth = function(){
    $('.topCollections-clear .icon-clear').on(clickEv, function() {
      var url = location.pathname ;
      createUrl(url,url);
    });
  }
  var applyFilterMobile = function(){
    $('.sidebar-bottom .sidebarMobile-close').on(clickEv, function() {
      var url = location.pathname + "?" + newQuery;
      createUrl(url,Shopify.queryParam);
      $('.collection-leftsidebar').removeClass('active');
      $('body').removeClass('active-sidebar');
    });
  }
  var paginationCollection = function(){
    $('.pagination-collection li a').on(clickEv, function(event) {
      event.preventDefault();
      var linkPage = $(this).attr("href").match(/page=\d+/g);
      if (linkPage) {
        Shopify.queryParams.page = parseInt(linkPage[0].match(/\d+/g));
        if (Shopify.queryParams.page) {
          newQuery = jQuery.param(Shopify.queryParams).replace(/%2B/g, '+');
		  var url = location.pathname + "?" + newQuery;
          createUrl(url,Shopify.queryParam);
          $('body,html').animate({scrollTop:0},1,'swing');
        }
      }
    });
  }
  var removeFilter = function(){
    $('.collection-leftsidebar').removeClass('active');
    $('body').removeClass('active-sidebar');
  }
  var activeFilter = function(){
    $('.collection-leftsidebar').addClass('active');
    $('body').addClass('active-sidebar');
  }

    $(document).on('click', function(event) {
        if (!$(event.target).closest(".collection-leftsidebar, .show-leftsidebar").length && $('.collection-leftsidebar').hasClass('active')) {
            $('.collection-leftsidebar').removeClass('active');
            $('body').removeClass('active-sidebar');
        }
    });
  var showFilter = function(){
    $('.show-leftsidebar').on(clickEv, function(e) {
      if (e && e.preventDefault) e.preventDefault();
      if($('.collection-leftsidebar').hasClass('active')){
        removeFilter();
      }
      else{
        activeFilter();
      }
    });
    $('.close-leftsidebar').on(clickEv, function(e) {
      if (e && e.preventDefault) e.preventDefault();
      removeFilter();
    });
  }
  var collectionTopFilter = function(){
    $(".topCollections-title").on(clickEv, function() {
      var content = $(this).parents('.topCollections-block');
      if(content.hasClass('active-popup')){
        content.removeClass('active-popup');
        content.find('.topCollections-content').hide("normal");
      }
      else{
        $('.topCollections-block').removeClass('active-popup');
        $('.topCollections-content').hide("normal");
        content.addClass('active-popup');
        content.find('.topCollections-content').show("normal");
      }
    });
  }
  
  init();

  if(checkCollection != 0){
  filterClick();
    initPriceSlider();

	}
  clearFilterMobile();
  clearFilterFullwidth();
  applyFilterMobile();
  paginationCollection();
  showFilter();
  collectionTopFilter();
}

function handleAnimate(){
    
    $('[data-animate]').each(function(){
      
      var $toAnimateElement = $(this);
      
      var toAnimateDelay = $(this).attr('data-delay');
      
      var toAnimateDelayTime = 0;
      
      if( toAnimateDelay ) { toAnimateDelayTime = Number( toAnimateDelay ); } else { toAnimateDelayTime = 200; }
      
      if( !$toAnimateElement.hasClass('animated') ) {
        
        $toAnimateElement.addClass('not-animated');
        
        var elementAnimation = $toAnimateElement.attr('data-animate');
        
        $toAnimateElement.appear(function () {
          setTimeout(function() {
            $toAnimateElement.removeClass('not-animated').addClass( elementAnimation + ' animated');
          }, toAnimateDelayTime);
          
        },{accX: 0, accY: -50},'easeInCubic');
        
      }
    });
}

function syncAccountReturnTo($scope){
  var $context = ($scope && $scope.length) ? $scope : $(document);
  var returnTo = window.location.pathname + window.location.search + window.location.hash;

  $context.find('input[name="return_to"][data-return-to-current]').each(function() {
    $(this).val(returnTo);
  });
}

function lightboxAccount(){
  var isAccountRoute = /^\/account(?:\/|$)/.test((window.location.pathname || '').toLowerCase());

  var getRoot = function(){
    return $('#top-activeRight').length ? $('#top-activeRight') : $('#top');
  };

  var normalizeModalTab = function(rawTarget){
    if (rawTarget === 'account-lightbox-register' || rawTarget === 'account-register' || rawTarget === 'register') {
      return 'account-lightbox-register';
    }
    return 'account-lightbox-login';
  };

  var normalizeSidebarTab = function(rawTarget, explicitTab){
    if (explicitTab) return explicitTab;
    if (rawTarget === 'account-lightbox-register' || rawTarget === 'account-register' || rawTarget === 'register') {
      return 'account-register';
    }
    return 'account-login';
  };

  var openAccountSidebar = function(sidebarTab){
    if ($('#top').length) $('#top').attr('id', 'top-activeRight');
    var $root = getRoot();
    if (!$root.length) return false;

    var $sidebar = $root.find('.info-header-sidebar');
    if (!$sidebar.length) return false;
    var hasAuthForms = $sidebar.find('form input[name="customer[email]"], form input[name="customer[password]"]').length > 0;
    if (!hasAuthForms) return false;

    $root.find('.info-header .info-header-item').removeClass('active-show');
    $sidebar.addClass('active-show');
    $root.find('.info-header').addClass('active');
    $('body').addClass('active-overflow');

    var $tab = $sidebar.find('.login-register-content .nav-tabs a[data-target="#' + sidebarTab + '"], .login-register-content .nav-tabs a[href="#' + sidebarTab + '"]');
    if ($tab.length && $.fn.tab) {
      $tab.tab('show');
    }

    syncAccountReturnTo($sidebar);
    return true;
  };

  var openAccountModal = function(modalTab){
    var $modal = $('#lightbox-account');
    if (!$modal.length || !$.fn.modal) return false;
    var hasAuthForms = $modal.find('form input[name="customer[email]"], form input[name="customer[password]"]').length > 0;
    if (!hasAuthForms) return false;

    syncAccountReturnTo($modal);
    $modal.modal('show');

    var $tab = $modal.find('.login-register-content .nav-tabs a[data-target="#' + modalTab + '"], .login-register-content .nav-tabs a[href="#' + modalTab + '"]');
    if ($tab.length && $.fn.tab) {
      $tab.tab('show');
    }
    return true;
  };

  var openFromHash = function(){
    if (isAccountRoute) return;

    var hash = window.location.hash;
    if (!hash) return;

    var target = hash.replace('#', '');
    if (target === 'recover') return;

    var modalTab = normalizeModalTab(target);
    var sidebarTab = normalizeSidebarTab(target);

    if (getWidthBrowser() <= 991) {
      openAccountSidebar(sidebarTab);
      return;
    }
    openAccountModal(modalTab);
  };

  syncAccountReturnTo();

  if (isAccountRoute) {
    // Never open account modal/side-panel on native customer pages.
    $('[data-account]').removeAttr('data-toggle').removeAttr('data-target');
    $(document).off(clickEv + '.accountLinks', '[data-account]');
    $(window).off('hashchange.accountLinks');
    return;
  }

  $(document).off(clickEv + '.accountLinks', '[data-account]');
  $(document).on(clickEv + '.accountLinks', '[data-account]', function(e) {
    var isMobile = getWidthBrowser() <= 991;
    var target = $(this).data('name');
    var modalTab = normalizeModalTab(target);
    var sidebarTab = normalizeSidebarTab(target, $(this).data('mobile-account'));
    var handled = false;

    if (isMobile) {
      handled = openAccountSidebar(sidebarTab);
      if (!handled) return;
    } else {
      handled = openAccountModal(modalTab);
    }

    if (handled) {
      if (e && e.preventDefault) e.preventDefault();
      if (e && e.stopPropagation) e.stopPropagation();
    }
  });

  openFromHash();

  $(window).off('hashchange.accountLinks');
  $(window).on('hashchange.accountLinks', function() {
    openFromHash();
  });
}

function addStickyScroll(scr,check){
  var offset_top_1 = $('#product-image').offset().top;
  var offset_top_2 = $('#product-information').offset().top;
  var hieght_as = $("#product-image").height();
  var hieght_affix_as = $('#product-information').height();
  var hieght = Math.ceil(offset_top_1 + hieght_as);
  var hieght_affix = Math.ceil(offset_top_2 + hieght_affix_as );
  
  var scrollTop = function(scr){
    
    if(scr > offset_top_1  && (scr+hieght_affix) < hieght){
      if(!$('#product-information').hasClass('affix-product')){
        $('#product-information').addClass('affix-product');
        $('#product-information').css({'top': '100px', 'height': 'auto'});
      }
    }
    else if( scr < offset_top_1 ){
      if($('#product-information').hasClass('affix-product')){
        $('#product-information').removeClass('affix-product');
        $('#product-information').css({'top': '0px', 'height': '100%'});
      }
    }
    else if( hieght_affix >= hieght ){
      if($('#product-information').hasClass('affix-product')){
        var top_px = (hieght_as - hieght_affix_as) + 'px';
        $('#product-information').removeClass('affix-product');
        $('#product-information').css({'top': top_px, 'height': '100%'});
      }
    }
  }
  var scrollBottom = function(scr){
    if(scr < offset_top_2 && scr > offset_top_1 ){
      if(!$('#product-information').hasClass('affix-product')){
        $('#product-information').addClass('affix-product');
        $('#product-information').css({'top': '100px', 'height': 'auto'});
      }
    }
    else if(scr < offset_top_1){
      if($('#product-information').hasClass('affix-product')){
        $('#product-information').removeClass('affix-product');
        $('#product-information').css({'top': '0px', 'height': '100%'});
      }
    }
    else if(scr > hieght){
      if($('#product-information').hasClass('affix-product')){
        var top_px = (hieght_as - hieght_affix_as) + 'px';
        $('#product-information').removeClass('affix-product');
        $('#product-information').css({'top': top_px, 'height': '100%'});
      }
    }
  }
  if(check == 1 && getWidthBrowser() > 767 ){
     scrollTop(scr);
  }
  if(check == 2 && getWidthBrowser() > 767 ){
     scrollBottom(scr);
  }
}

function buyNowProduct(){
  $('[data-buy-now ]').on(clickEv, function() {

    var $this = $(this);
    var form = $this.parents('form');

		if($('.refrigerant-disabled').length) {
            if ($('#epa_number').val().length) {
                $('.error-message').removeClass('activated')

                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: form.serialize(),
                    dataType: 'json',
                    error: function(){
                        window.location = '/checkout';
                        return false;
                    },
                    success: function(){
                        window.location = '/checkout';
                        return false;
                    },
                    cache: false
                });
                return false;
            }else {
                if ($('.error-message').hasClass('activated')) {
                    $('.error-message').removeClass('animate-shake');

                    setTimeout(function () {
                        $('.error-message').addClass('animate-shake')

                    }, 410)
                }
                    $('.error-message').addClass('activated')
            }
        }else {
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: form.serialize(),
                dataType: 'json',
                error: function(){
                    window.location = '/checkout';
                    return false;
                },
                success: function(){
                    window.location = '/checkout';
                    return false;
                },
                cache: false
            });
            return false;
        }
		return false;

  });
}

function clickShowLinklistFooter(){
  $('[data-linklist-title]').on(clickEv, function() {
    if(touch == false && getWidthBrowser() <= 767 ){
      var classFooter = $(this).parent().find('[data-linklist-content]');
      if(classFooter.hasClass('active')){
        $(this).find('.cs-icon').toggleClass('icon-ios-plus-empty icon-ios-minus-empty');
        classFooter.removeClass('active');
        classFooter.hide('fast');
      }
      else{
        $(this).find('.cs-icon').toggleClass('icon-ios-minus-empty icon-ios-plus-empty');
        classFooter.addClass('active');
        classFooter.show('fast');
      }
    }
  });
}

$(window).scroll(function() {
  
  if( checkProductV3 == 1 ){
    var scrollTop = $(this).scrollTop();
    var check = 0;
    if(scrollTop > checks_scroll){
      check = 1;
    }
    else if(scrollTop < checks_scroll){
      check = 2;
    }
    checks_scroll = scrollTop;
    addStickyScroll(scrollTop, check);
  }
  
});

$( window ).resize(function() {
  
  //handleDropdown();
  if( checkProductV3 == 1 ){
    var scrollTop = $(this).scrollTop();
    var check = 0;
    if(scrollTop > checks_scroll){
      check = 1;
    }
    else if(scrollTop < checks_scroll){
      check = 2;
    }
    checks_scroll = scrollTop;
    addStickyScroll(scrollTop, check);
  }
});

$(window).ready(function($) {
  
  handleDropdown();
  
  clickShowLinklistFooter();
  
  lightboxAccount();
  
  buyNowProduct();
  
  
    if(touch == false && getWidthBrowser() > 992 ){
      handleAnimate(); 
    }
    else{
      $('.not-animated').css("opacity","1");
    }
  
  
  tagFilterCollection();
  
  sidebarBlog();
  
  showPassword();

  capsLockHint();
  
  showItemMobile();

  sliderProduct();
  
  sliderBlog();

  handleScrollTop();

  colorwarches();


	$('[data-toggle="tooltip"]').tooltip();

  handleQuantity();

  toggleTagsFilter();

  updateScrollThumbsQS();

  showMenuMobile();
});


$(window).load(function() { 
  
  

  ModalNewsletter();
  


});
